import axios from "./axios";
import { useAuth } from "../hooks/appHooks";

const REFRESH_URL = "/users/refresh-token";

const useRefreshToken = () => {
  const { auth, setAuth } = useAuth();

  const refresh = async () => {
    console.log("CALLING REFRESH TOKEN...");
    const response = await axios.post(
      `${REFRESH_URL}`,
      {
        refresh_token: auth.refreshToken,
      },
      { headers: { "Access-Control-Allow-Origin": "*" } }
    );
    setAuth((prev) => {
      console.log(JSON.stringify(prev));
      return {
        ...prev,
        token: response?.data?.data?.token,
        refreshToken: response?.data?.data?.refreshToken,
      };
    });
    return {
      token: response?.data?.data?.token,
      refreshToken: response?.data?.data?.refreshToken,
    };
  };
  return refresh;
};

export default useRefreshToken;
